import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IAuditHistory, defaultValue } from 'app/shared/model/audit-history.model';

export const ACTION_TYPES = {
  FETCH_AUDITHISTORY_LIST: 'auditHistory/FETCH_AUDITHISTORY_LIST',
  FETCH_AUDITHISTORY: 'auditHistory/FETCH_AUDITHISTORY',
  CREATE_AUDITHISTORY: 'auditHistory/CREATE_AUDITHISTORY',
  UPDATE_AUDITHISTORY: 'auditHistory/UPDATE_AUDITHISTORY',
  DELETE_AUDITHISTORY: 'auditHistory/DELETE_AUDITHISTORY',
  RESET: 'auditHistory/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAuditHistory>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type AuditHistoryState = Readonly<typeof initialState>;

// Reducer

export default (state: AuditHistoryState = initialState, action): AuditHistoryState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_AUDITHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_AUDITHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_AUDITHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_AUDITHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_AUDITHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_AUDITHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_AUDITHISTORY):
    case FAILURE(ACTION_TYPES.CREATE_AUDITHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_AUDITHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_AUDITHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUDITHISTORY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUDITHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_AUDITHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_AUDITHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_AUDITHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/audit-histories';

// Actions

export const getEntities: ICrudGetAllAction<IAuditHistory> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_AUDITHISTORY_LIST,
  payload: axios.get<IAuditHistory>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IAuditHistory> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_AUDITHISTORY,
    payload: axios.get<IAuditHistory>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IAuditHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_AUDITHISTORY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IAuditHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AUDITHISTORY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IAuditHistory> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_AUDITHISTORY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
